<script lang="ts" setup>
import type { PeriodOptionType } from './types/periodField.type';
import type { PeriodPresetSidebarPropsType } from './types/periodPresetSidebarProps.type';

const { name, options, modelValue } = defineProps<PeriodPresetSidebarPropsType>();

const emit = defineEmits<{
  'update:modelValue': [option: PeriodOptionType];
}>();
</script>

<template>
  <div class="flex flex-col">
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="text-left w-full px-2 py-1.5 rounded hover:bg-slate-50"
      :class="{ 'bg-slate-100 font-semibold': modelValue === option.value }"
      :aria-pressed="modelValue === option.value"
      :data-testid="`${name}-${option.value}`"
      @click="emit('update:modelValue', option.value)"
    >
      <span class="block text-sm leading-tight">{{ option.label }}</span>
      <span v-if="option.subLabel" class="block mt-0.5 text-xs leading-tight text-slate-500">{{
        option.subLabel
      }}</span>
    </button>
  </div>
</template>
